const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const blockIconURI = require('./ml5-logo.svg');
const menuIconURI = blockIconURI;
const ml5 = require('ml5');

class MachineBlocks {
    constructor(runtime) {
        /**
         * The runtime instantiating this block package.
         * @type {Runtime}
         */
        this.runtime = runtime;
    }

    /**
     * The key to load & store a target's test-related state.
     * @type {string}
     */
    static get STATE_KEY() {
        return "Scratch.machineLearning";
    }

    /**
     * @returns {object} metadata for this extension and its blocks.
     */
    getInfo() {
        return {
            // 详细介绍：https://github.com/LLK/scratch-vm/blob/develop/docs/extensions.md
            // Required: the machine-readable name of this extension.
            // Will be used as the extension's namespace.
            id: "machineLearning",
            name: "机器学习",
            // Optional: URI for an icon to be displayed in the blocks category menu.
            menuIconURI: menuIconURI,
            // Optional: URI for a block icon, to display at the edge of each block for this
            blockIconURI: blockIconURI,
            // Optional: Link to documentation content for this extension.
            // If not present, offer no link.
            // docsURI: 'https://....',
            // 插件右上角的硬件连接状态显示按钮
            showStatusButton: false,
            blocks: [
                {
                    opcode: 'initExtractor',
                    blockType: BlockType.COMMAND,
                    text: '初始化特征提取器'
                    // text: formatMessage({
                    //     id: 'machineLearning.initExtractor',
                    //     default: '初始化特征提取器',
                    //     description: 'initExtractor'
                    // }),
                },
                {
                    opcode: 'featureExtraction',
                    blockType: BlockType.REPORTER,
                    text: '特征提取',
                    disableMonitor: true
                    // text: formatMessage({
                    //     id: 'machineLearning.featureExtraction',
                    //     default: '特征提取',
                    //     description: 'featureExtraction'
                    // }),
                },
                {
                    opcode: "KNNaddFeature",
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: formatMessage({
                        id: "machineLearning.KNNaddFeature",
                        default: "KNN 添加特征 [addFeature] 标签 [featureTag]",
                        description: "KNNaddFeature",
                    }),
                    arguments: {
                        addFeature: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        },
                        featureTag: {
                            type: ArgumentType.STRING,
                            defaultValue: '人类',
                        },
                    },
                },
                {
                    opcode: "classificationFeature",
                    blockType: BlockType.REPORTER, // BOOLEAN, COMMAND
                    text: 'KNN 分类特征 [classificationFeature]',
                    // text: formatMessage({
                    //     id: "machineLearning.classificationFeature",
                    //     default: "KNN 分类特征 [classificationFeature]",
                    //     description: "classificationFeature",
                    // }),
                    arguments: {
                        classificationFeature: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        },
                    },
                },
                {
                    opcode: 'classificationClear',
                    blockType: BlockType.COMMAND,
                    text: 'KNN 分类清除',
                    // text: formatMessage({
                    //     id: 'machineLearning.classificationClear',
                    //     default: 'KNN 分类清除',
                    //     description: 'classificationClear'
                    // }),
                }, 
                {
                    opcode: 'knnSave',
                    blockType: BlockType.COMMAND,
                    text: 'KNN 保存模型',
                }, {
                    opcode: 'knnLoad',
                    blockType: BlockType.COMMAND,
                    text: 'KNN 加载模型 [MODEL]',
                    arguments: {
                        MODEL: {
                            type: ArgumentType.STRING,
                            defaultValue: '点击积木加载模型'
                        }
                    }
                }
                
            ]
        }
    }


    initExtractor () {
        return new Promise((resolve, reject) => {
            // this.featureExtractor = ml5.featureExtractor('MobileNet', {}, resolve)
            this.featureExtractor = ml5.featureExtractor('mobilenet', {
                mobilenetURL: '/static/ml5/model/mobilenet_v1_050_224/model.json',
                graphModelURL: '/static/ml5/model/mobilenet_v1_050_224/imagenet/model.json'
            }, resolve);
        })
    }
    featureExtraction () {
        if (this.featureExtractor) {
            const canvas = this.runtime.renderer.canvas;
            this.runtime.renderer.draw();
            try {
                return this.featureExtractor.infer(canvas)
            } catch (error) {
                console.warn('infer', error)
                alert(error)
                // throw new Error('No sprite associated with this target.');
                // return Promise.reject(new Error('No Audio Context Detected'));
                // vm.emit('showAlert', {
                //     message: '分类器推理失败，请检查模型是否正常加载或拥有有效分类',
                //     type: 'warn'
                // })
            }
        }
    }

    KNNaddFeature (args) {
        if (!this.knnClassifier) {
            this.knnClassifier = ml5.KNNClassifier()
        }
            
        if (args.addFeature && 'string' != typeof args.addFeature) {
            this.knnClassifier.addExample(args.addFeature, args.featureTag)
        } else {
            // console.log('无效特征输入,请确认已经初始化了特征提取器')
            // alert('无效特征输入,请确认已经初始化了特征提取器')
            // vm.emit('showAlert', {
            //     message: '无效特征输入,请确认已经初始化了特征提取器',
            //     type: 'warn'
            // })
        }
        
    }
    classificationFeature (args) {
        if (this.knnClassifier) {
            if (this.knnClassifier.getNumLabels() <= 0) {
                // alert('无效特征输入,请确认已经初始化了特征提取器')
                // console.log('无效特征输入,请确认已经初始化了特征提取器')
                return;
            }
            const mapStringToIndex = this.knnClassifier.mapStringToIndex;
            if (typeof args.classificationFeature == 'string') {
                return;
            }
            return new Promise((resolve, reject) => {
                this.knnClassifier.classify(args.classificationFeature, (error, result) => {
                    if (error) {
                        reject(error);
                    } else if (void 0 === result.classIndex) {
                        resolve(mapStringToIndex[result.label]);
                    } else {
                        const confidencesByLabel = result.confidencesByLabel;
                        const obj = Object.keys(confidencesByLabel).reduce((el, index) => {
                            if (confidencesByLabel[index] > el.value) {
                                el = {
                                    key: index,
                                    value: confidencesByLabel[index]
                                };
                            }
                            return el;
                        }, {
                            key: 'None',
                            value: -1
                        });
                        resolve(obj.key);
                    }
                });
            });
        }
    }
    classificationClear () {
        if (this.knnClassifier) {
            this.knnClassifier.clearAllLabels();
        }
    }
    knnLoad (args, util) {
        const _this = this
        let blocks = util.getBlocks()
        let blockId = util.blockId
        let thisBlock = blocks[blockId]
        let textBlock = blocks[thisBlock.inputs.MODEL.block]
        // console.log(args, thisBlock)
        if (!this.knnClassifier) {
            this.knnClassifier = ml5.KNNClassifier()
        }
        //判断浏览器是否支持FileReader接口
        if(typeof window.FileReader == 'undefined'){
            return alert('你的浏览器不支持FileReader接口')
        }
        let fileinput = document.createElement('input')
        fileinput.setAttribute('type', 'file')
        return new Promise((resolve, reject) => {
            fileinput.onchange = (event) => {
                // console.log(event)
                let file = fileinput.files[0];
                filename = file.name.split('.')[0];
                
                let reader = new FileReader();
                reader.onload = function() {
                    try {
                        _this.knnClassifier.load(JSON.parse(this.result))
                        textBlock.fields['TEXT'].value = file.name
                        _this.runtime.requestBlocksUpdate()
                        resolve()
                    } catch (error) {
                        reject()
                    }
                }
                reader.readAsText(file);
            }
            fileinput.click()
        })
    }
    knnSave () {
        if (!this.knnClassifier) {
            this.knnClassifier = ml5.KNNClassifier()
        }
        this.knnClassifier.save('model.json')
    }

}

module.exports = MachineBlocks;
